import cloneDeep from "lodash.clonedeep";

export const getChartStyle = (state, variables) => {
  const colors = {};

  if (state.theme === "dark-theme") {
    colors.bg = variables.primaryBgDt;
    colors.bgRevers = variables.primaryBgLt;
    colors.text = variables.regularTextDt;
  } else {
    colors.bg = variables.primaryBgLt;
    colors.bgRevers = variables.primaryBgDt;
    colors.text = variables.regularTextLt;
  }

  state.chartOption.textStyle = { color: colors.text };
  if (state.chartOption.legend)
    state.chartOption.legend.textStyle = { color: colors.text };
  if (state.chartOption.series[0].itemStyle)
    state.chartOption.series[0].itemStyle = {
      borderWidth: 3,
      borderColor: colors.bg
    };
};

export const buildChart = state => {
  let newData;

  switch (state.type) {
    case "type-1":
      newData = cloneDeep(state.pie);
      break;
    case "type-2":
      newData = cloneDeep(state.doughnut);
      break;
    case "type-3":
      newData = cloneDeep(state.pie);
      break;
  }

  newData.series[0].name = state.title;
  newData.series[0].data = state.chartData;
  if (state.colors) newData.color = state.colors;
  state.chartOption = cloneDeep(newData);

  state.setColorTheme();
};
